<template>
    <section class="text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'loups-garous-prepare' }" />
        <Title class="ml-5">Loups Garous</Title>
        <div class="relative flex flex-col gap-y-2">
            <p class="text-gray-400 flex justify-between">
                <span>{{NumberOfVillageoisAlive}} villageois</span>
                <span>{{NumberOfLoupsGarousAlive}} loups garous</span>
            </p>
            <PlayerCard v-for="(player, index) in Players" :key="`${player.name}-${player.role}-${player.dead}`" 
                :player="player"
                @select="selected = (selected == player) ? null : player"
                @dead="SetDead({ index, dead: true })"
                @alive="SetDead({ index, dead: false })" />
        </div>
        <Modal :open="selected != null" @close="selected = null">
            <template v-slot:title>
                <p class="text-5xl">{{selected && selected.name}}</p>
            </template>
            <template v-if="selected">
                <img class="w-full pt-12" :src="require(`@/assets/img/${selected.role}.png`)">
                <p class="font-bold text-4xl pt-5">{{selected.role}}</p>
            </template>
        </Modal>
    </section>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import PlayerCard from '@/components/PlayerCard'
import Modal from '@/components/Modal'
export default {
    components: {
        Modal,
        PlayerCard
    },
    data: function () {
        return {
            selected: null
        }
    },
    computed: {
        ...mapState('LoupsGarous', ['Players']),
        ...mapGetters('LoupsGarous', ['NumberOfLoupsGarousAlive', 'NumberOfVillageoisAlive'])
    },
    methods: {
        ...mapMutations('LoupsGarous', ['SetDead'])
    }
}
</script>